import React, { useEffect, useState } from "react"
import { ThemeProvider } from "styled-components"
// import { coordinates } from "../helpers/geolocation"
import { gql } from "apollo-boost"
import { useQuery } from "@apollo/react-hooks"
import withApolloClient from "../components/withApolloClient"
import useGeolocation from "../hooks/useGeolocation"
import { setBranches } from "../utils/utils"

const branchesQuery = gql`
  query branchesByLocationQuery(
    $lat: Float
    $lng: Float
    $distance: Int
    $name: String
    $limit: Int
    $offset: Int
    $forPickup: Boolean
  ) {
    branchesByLocation(
      lat: $lat
      lng: $lng
      distance: $distance
      name: $name
      limit: $limit
      offset: $offset
      forPickup: $forPickup
    ) {
      _id
      name
      lng
      lat
      fbUrl
      address1
      address2
      distance
      close
      open
      schedule
      email
      phone
    }
  }
`

const DEFAULT_APP_LOCATION = { lng: 121.0300684, lat: 14.65695944 } //{ lng: 121.0542674, lat: 14.5834442 }
const APP_BRANCH_LOCATION = "ace_app_branch"

export const ActiveBranch = React.createContext({
  activeBranch: null,
  refreshBranch: () => { },
  error: null
})

const ActiveBranchProvider = ({ children }) => {
  const [activeBranch, setActiveBranch] = useState(null)
  const [allBranches, setAllBranches] = useState([])
  const geolocation = useGeolocation()
  // const [error, setError] = useState(geolocation.error)
  const { data: branchesData, loading: branchesLoading, fetchMore } = useQuery(
    branchesQuery,
    {
      variables: {
        name: '',
        distance: 20000,
        limit: 100,
        forPickup: true,
        lat: geolocation?.latitude
          ? geolocation.latitude
          : DEFAULT_APP_LOCATION.lat,
        lng: geolocation?.longitude
          ? geolocation.longitude
          : DEFAULT_APP_LOCATION.lng,
      },
    }
  )

  // console.log("gelocation coordinates::", geolocation, error)

  useEffect(() => {
    const activeBranch = JSON.parse(localStorage.getItem(APP_BRANCH_LOCATION))
    if (activeBranch && activeBranch.userSaved) {
      setActiveBranch(activeBranch)
    } else if (
      branchesData != null &&
      branchesData.branchesByLocation &&
      branchesData.branchesByLocation.length > 0
    ) {
      setActiveBranch(branchesData.branchesByLocation[0])
      setAllBranches(branchesData.branchesByLocation)
      localStorage.setItem(
        APP_BRANCH_LOCATION,
        JSON.stringify(branchesData.branchesByLocation[0])
      )
      setBranches(JSON.stringify(branchesData.branchesByLocation))
    }

  }, [branchesData])

  const refreshBranch = () => {
    const activeBranch = JSON.parse(localStorage.getItem(APP_BRANCH_LOCATION))
    if (activeBranch && activeBranch.userSaved) {
      setActiveBranch(activeBranch)
    }
  }

  return (
    <ActiveBranch.Provider
      value={{ activeBranch: activeBranch, refreshBranch: refreshBranch, error: geolocation.error && geolocation.error.code }}
    >
      {children}
    </ActiveBranch.Provider>
  )
}

export default withApolloClient(ActiveBranchProvider, {
  client: "seeAllClient",
})
